













































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Prop, Watch } from 'vue-property-decorator';

export default class SwFilterInput extends SwExtendedVue {
  /* two way binding for main v-model */
  @Prop()
  value: string;

  @Prop()
  placeholdertext: string;
  focused: boolean = false;

  internalValue: string | number | boolean = this.value;
  @Watch('value')
  onValueChange(val: string) {
    this.internalValue = val;
  }
  @Watch('internalValue')
  onInternalValueChange() {
    this.$emit('input', this.internalValue);
  }

  onKeyup(event: KeyboardEvent) {
    this.$emit('keyup', event);
    if (event.key === 'Enter') {
      this.$emit('enter');
    }
  }

  public focus() {
    const inputEl = this.$refs.input as HTMLElement;
    if (inputEl) { inputEl.focus(); }
  }
}
